<template>
  <div>
    <OhsHeader :headerMenuList="headerMenuList"></OhsHeader>
    <OhsMain>
      {{ res }}
      <mavon-editor v-model="mavonEditorValue" />
    </OhsMain>
    <OhsFooter></OhsFooter>
  </div>
</template>

<script>
import OhsHeader from '@/components/layoutBox/OhsHeader.vue';
import OhsMain from '@/components/layoutBox/OhsMain.vue';
import OhsFooter from '@/components/layoutBox/OhsFooter.vue';
import api from '@/assets/api/test.js';
// import request from '@/utils/request';
export default {
  name: 'ownSpace',
  components: {
    OhsHeader,
    OhsMain,
    OhsFooter,
  },
  props: {},
  data() {
    return {
      headerMenuList: [
        {
          label: '编写',
          routerPath: 'aaaa',
        },
        {
          label: '我的',
          routerPath: 'aaaa',
        },
      ],
      mavonEditorValue: '',
      res: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    this.testGet();
  },
  mounted() {},
  methods: {
    testGet() {
      api.getTest({ a: '11' }).then((res) => {
        this.res = res;
        console.log(res, 'res0000');
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
